module.exports = __webpack_public_path__ + "static/media/ic_video_off.505ef9e1.svg";